import {
  Modal,
  useSnackbar,
  useUnsavedChangesStore,
} from '@sunrise-ui/primitives';
import React, { useCallback } from 'react';
import { ScrollView } from 'react-native';
import { SessionForm } from './SessionForm';

type Props = {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  sessionId: string;
  eventId: string;
  communityId?: string;
};

export function SessionEditModal({
  isOpen,
  setIsOpen,
  sessionId,
  eventId,
  communityId,
}: Props) {
  const { showSnackbar } = useSnackbar();
  const { guard } = useUnsavedChangesStore();

  const handleClose = useCallback(() => {
    guard(() => setIsOpen(false));
  }, [guard, setIsOpen]);

  const handleSuccess = () => {
    setIsOpen(false);
    showSnackbar({ text: 'Session updated successfully', type: 'success' });
  };

  return (
    <Modal visible={isOpen} hide={handleClose} title="Edit Session">
      <ScrollView style={{ flex: 1, width: '100%' }}>
        <SessionForm
          isEdit
          sessionId={sessionId}
          eventId={eventId}
          communityId={communityId}
          onCancel={handleClose}
          onSuccess={handleSuccess}
        />
      </ScrollView>
    </Modal>
  );
}
